import { useDayPicker, type NavProps } from 'react-day-picker';

import Box from '../../components/Box/Box.jsx';
import IconButton from '../../components/IconButton/IconButton.jsx';

const CalendarNavigation = (props: NavProps) => {
  const context = useDayPicker();
  const onPrevMonthClick = () => {
    if (context.previousMonth) {
      context.goToMonth(context.previousMonth);
    }
  };

  const onNextMonthClick = () => {
    if (context.nextMonth) {
      context.goToMonth(context.nextMonth);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        position: 'absolute',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 4px 4px 4px',
      }}
    >
      <IconButton
        aria-label="Previous Month"
        variant="icon"
        color="secondary"
        onClick={onPrevMonthClick}
        icon="ArrowLeft"
        data-testId="previous-month-button"
      />

      <IconButton
        aria-label="Next Month"
        variant="icon"
        color="secondary"
        onClick={onNextMonthClick}
        icon="ArrowRight"
        data-testId="next-month-button"
      />
    </Box>
  );
};

export default CalendarNavigation;
